import styles from './FinalizarCadastro.module.css';
import servLogin from "../../services/login/servLogin";
import servTermoConsentimento from "../../services/login/servTermoConsentimento";
import servParam from '../../services/login/servParam';

import { faBoxOpen, faFileCircleCheck, faFileSignature, faFileWaveform, faQuestion, faQuestionCircle, faUserTie } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MenuIcon from "@mui/icons-material/Menu";
import { Alert, Box, CircularProgress, CssBaseline, FormControl, InputLabel, Modal, Snackbar, Toolbar, Tooltip, Menu, MenuItem, Checkbox, FormControlLabel } from "@mui/material"
import { AppBar, Drawer, DrawerHeader } from "../../components/Drawer/Drawer";
import DrawerButtonThatOpens from "../../components/Drawer/DrawerButton";

import { WhiteInput } from "../../components/Inputs/InputText";
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";

import { linkStyle } from "../../components/Inputs/Link";
import { format } from "date-fns";
import useStateRef from "react-usestateref";

import { useGDSelector } from "../../hooks";
import { useDispatch } from "react-redux";
import { solicitarHomolog, logout } from "../../state/slices/userSlice";
import { style as modalStyle } from "../../components/Loading/Loading";

import { ImageInput } from "../../components/Inputs/ImageInput";
import  QuaseLa  from "../../assets/images/Quasela.svg"
import ImagemLateralE from "../../assets/images/Lateral01.svg";
import ImagemLateralD from "../../assets/images/Lateral02.svg";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { HelperText } from "../../components/Errors/HelperText";
import InputMask from "react-input-mask";
import { formatarCpf, formatarTelefone } from "../../infra/utils/FormataValores";
import { validarCpf } from "../../infra/utils/ValidacaoCpf";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBR from "date-fns/locale/pt-BR";

const schema = yup.object().shape({
    nome: yup.string().required("Este campo é obrigatório").matches("([A-Za-z]( )[A-Za-z]+)", "Deve conter nome e sobrenome (somente letras)").max(100, "Deve conter até 100 caracteres"), 
    celular: yup.string().required("Este campo é obrigatório"), 
    cpf: yup.string().required("Este campo é obrigatório").matches("([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})", "CPF deve estar no formato correto"), 
    email: yup.string().email("O e-mail informado deve ser válido").required("Este campo é obrigatório").max(100, "Deve conter até 100 caracteres"),
    empresa: yup.string().required("Valor inválido. Este campo é obrigatório").max(100, "Deve conter até 100 caracteres"),
    creadoc: yup.string().required("Valor inválido. Este campo é obrigatório").matches(/^\d+$/, "Deve conter somente números").max(15, "Deve conter até 15 caracteres"),
    dataValidadeCrea: yup.date().nullable().typeError("Valor inválido.").min(new Date(), "Data de Validade deve ser maior que a data atual."),
});

const ModalQuaseLaStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    height: '55%',
    backgroundColor: '#494949',
    color: "#B8B8B8",
    boxShadow: 24,
    borderRadius: 10,
    padding: "35px 40px",
};


const FinalizarCadastro = () => {
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openQuaseLa, setOpenQuaseLa] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [disableBtnConcluir, setDisableBtnConcluir] = useState(false);
    const [linkTermoConsentimento, setLinkTermoConsentimento] = useState('');
    const { register, control, handleSubmit, setValue, formState: { errors } } = useForm({ resolver: yupResolver(schema) });
    const user = useGDSelector(state => state.user);
    const [aceitaTermoConsentimento, setAceitaTermoConsentimento] = useStateRef(false);
    const [usaTermoConsentimento, setUsaTermoConsentimento, usaTermoConsentimentoRef] = useStateRef(0);
    const [termoConsentimentoDoc, setTermoConsentimentoDoc, termoConsentimentoDocRef] = useStateRef(0);
    const [prazoAnaliseCadRespTec, setPrazoAnaliseCadRespTec] = useState(null);
    
    const [logoA, setLogoA] = useState(null);

    const [isHidden, setIsHidden] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    const handleClickMenu = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleCloseMenu = () => {
        setAnchorEl(null);
    }

    useEffect(() => {
        const data = location.state;

        if (data.situacao === undefined) {
            if (!data) return;

            setValue("nome", data.Nome);
            setValue("celular", data.Celular);
            setValue("email", data.Email);
            setValue("cpf", data.CPF);
            setValue("dataValidadeCrea", null);

            recuperarImagem();
            recuperaDatasParametrizacao();
        } else {
            try {
                const recuperarDados = async () => {
                    const response = await servLogin.recuperarDadosResponsavel(data.codigoUsuario);

                    setValue("nome", response.Content.Nome);
                    setValue("celular", response.Content.Celular);
                    setValue("email", response.Content.Email);
                    setValue("cpf", response.Content.CPF);
                }

                setIsLoading(true);

                recuperarImagem();
                recuperarDados();
                recuperaDatasParametrizacao();

                setIsLoading(false);

            } catch (err) {
                setIsLoading(false);
                handleAlertError(err.response.data.Message);

                return;
            }
        }

        const recuperarParametros = async () => {
            try {
                setIsLoading(true);

                const params = await servParam.recuperarRespTecnicoParametros();

                setUsaTermoConsentimento(params.Content.UsaTermoConsentimento);
                setTermoConsentimentoDoc(params.Content.TermoConsentimentoDoc);

                if(usaTermoConsentimentoRef.current){
                   const termoConsentimento = await servParam.recuperarTermoConsentimento();
                   setLinkTermoConsentimento('data:application/pdf;base64,' + termoConsentimento.Content.Arquivo);
                }

                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);
                console.log("erro" + err);
            }
        };

        recuperarParametros();
    }, []);

    useEffect(() => {
        if(usaTermoConsentimentoRef.current){
            setDisableBtnConcluir(!aceitaTermoConsentimento);
        } else {
            setDisableBtnConcluir(false);
        }

    }, [ usaTermoConsentimento, aceitaTermoConsentimento]);

    const recuperarImagem = async () => {
        try {

            const response = await servLogin.recuperarImages();

            setLogoA(response.Content.UrlLogoAberta);

        } catch (err) {
            console.log(err);
        }
    }

    const recuperaDatasParametrizacao = async () => {
        const data = await servLogin.consultaAnaliseResponsavel(user.codigoUsuario);
        
        setPrazoAnaliseCadRespTec(data.Content.PrazoAnaliseCadastroRespTec);
    }

    const handleAlertError = (message) => {
        setOpen(true);
        setErrorMessage(message);
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            setOpen(false);
        }

        setOpen(false);
    }

    const handleCloseModal = () => {
        setOpenQuaseLa(false);
    }

    const createFormData = (data) => {
        const formData = new FormData();

        if(data.frenteCrea.length === 0 || data.versoCrea.length === 0 || !data.selfie.length) {
            handleAlertError("Para finalizar o cadastro, é necessário inserir todos os documentos.");

            return;
        }

        let cpf = formatarCpf(data.cpf);
        let celular = formatarTelefone(data.celular);
        let ddd = celular.slice(0, 2);
        celular = celular.slice(2);

        if(!validarCpf(cpf)) {
            setIsLoading(false);
            handleAlertError("O CPF informado é inexistente.");

            return false;
        }

        if(celular.length < 9) {
            setIsLoading(false);
            handleAlertError("O telefone informado é inválido.");

            return false;
        }

        formData.append("CreaFrente", data.frenteCrea[0]);
        formData.append("CreaVerso", data.versoCrea[0]);
        formData.append("FotoPessoal", data.selfie[0]);
        formData.append("CodigoResponsavel", user.codigoUsuario);
        formData.append("Empresa", data.empresa);
        formData.append("Crea", data.creadoc);
        formData.append("DddFone", ddd);
        formData.append("Celular", celular);
        formData.append("CPF", cpf);
        formData.append("Nome", data.nome);
        formData.append("Email", data.email);
        formData.append("DataValidadeCrea", data.dataValidadeCrea ? formataDataValidade(data.dataValidadeCrea) : null);

        return formData;
    }

    const formataDataValidade = (dataValidade) => {
        dataValidade.setHours(0);
        dataValidade.setMinutes(0);
        dataValidade.setSeconds(0);
        dataValidade.setMilliseconds(0);

        return new Date(dataValidade).toJSON();
    }

    const onClickFinalizarCad = handleSubmit ( async (data) => {
        try {
            if (!data) return;

            const formData = createFormData(data);

            setIsLoading(true);

            if(!formData) {
                setIsLoading(false);

                return;
            }

            await servLogin.continuarCadastro(formData); 

            if(usaTermoConsentimentoRef.current){
                let dto = {
                    CodigoResponsavel: user.codigoUsuario,
                    TermoConsentimentoDoc: termoConsentimentoDocRef.current,
                    Nome: data.nome,
                    Email: data.email,
                    DataAceite: format(new Date(), 'dd/MM/yyyy HH:mm:ss'),
                    Aceito: 1
                }

                await servTermoConsentimento.cadastrarTermoConsentimento(dto);
            }
            
            setIsLoading(false);
            
            dispatch(solicitarHomolog());

            navigate("/");
        } catch (err) {
            setIsLoading(false);
            handleAlertError(err.response.data.Message);
            
            return;
        }
    });

    const handleClickManual = () => {
        window.open('https://manuaisp3tec.useallcloud.com.br/', '_blank', 'noopener,noreferrer');
    }

    const onClickLogout = (e) => {
        dispatch(logout());
        navigate("/");
    }

    const abrirTermos = async () => {
        const r = await fetch(linkTermoConsentimento);
        const blob = await r.blob();
        window.open(URL.createObjectURL(blob));
    }

    return (
        <Box>
            <CssBaseline />    
            <AppBar position="fixed" open={true}>
                <Toolbar sx={{justifyContent: "space-between"}}>
                    Habilitação do responsável técnico  
                    <div className="dropdown">
                        { user && (
                            <span>{user.name}</span>
                        ) }
                        <button
                            aria-haspopup="true"
                            className="avatarButton"
                            onClick={handleClickMenu}
                        >
                            <FontAwesomeIcon icon={faUserTie} size="2x" /> 
                        </button>
                        <Menu 
                            open={openMenu} 
                            sx={{"& .MuiPaper-root": {
                                backgroundColor: "#494949",
                                color: "white"
                            }}} 
                            anchorEl={anchorEl} 
                            onClose={handleCloseMenu} 
                        >
                            <MenuItem onClick={abrirTermos} style={usaTermoConsentimentoRef.current ? {} : {display: "none"}}>Visualizar Termos de consentimento</MenuItem>
                            <MenuItem onClick={onClickLogout} >Logout</MenuItem>
                        </Menu>
                        <button
                            aria-haspopup="true"
                            className={styles.avatarButton}
                            onClick={handleClickManual}
                        >
                            <Tooltip title="Manual do sistema">
                                <FontAwesomeIcon icon={faQuestion} size="2x" /> 
                            </Tooltip>
                        </button>
                    </div>
                </Toolbar>
            </AppBar>
            <Drawer open={true} variant="permanent">
                <DrawerHeader>
                    <div style={{ width: "250px" }} className={styles.drawerLogo}>
                        <div className={styles.logoFull}>
                            <img src={logoA} alt="Logo cooperativa" />
                        </div>
                    </div>
                </DrawerHeader>
                <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "column", gap: "10px", padding: "9px" }}>
                    <DrawerButtonThatOpens open={true} name="" disabled={true}>
                            <MenuIcon />
                        </DrawerButtonThatOpens>
                        <DrawerButtonThatOpens open={true} name="Equipamentos" disabled={true}>
                            <FontAwesomeIcon icon={faBoxOpen} />
                        </DrawerButtonThatOpens>
                        <DrawerButtonThatOpens open={true} name="Orçamento estimado" disabled={true}>
                            <FontAwesomeIcon icon={faFileCircleCheck} />
                        </DrawerButtonThatOpens>
                        <DrawerButtonThatOpens open={true} name="Orçamento de conexão" disabled={true}>
                            <FontAwesomeIcon icon={faFileSignature} />
                        </DrawerButtonThatOpens>
                        <DrawerButtonThatOpens open={true} name="Solicitação. de vistoria" disabled={true}>
                            <FontAwesomeIcon icon={faFileWaveform} />
                    </DrawerButtonThatOpens>
                </Box>
            </Drawer>
            <main className={styles.fcMain}>
                    <div  className={styles.fcLeftImage}>
                        <img src={ImagemLateralE} alt="Mundo com duas pessoas" />
                    </div>
                    <div className={styles.fcCenterContent}>
                        <h1>Quase lá</h1>
                        <p>Antes de analisarmos o seu cadastro precisamos de mais alguns documentos.<FontAwesomeIcon title="O documento profissional é um documento que habilita o profissional para a elaboração de projetos elétricos, podendo ser o CREA ou outros documentos." style={{ marginLeft: "10px", width: "15px", height: "15px", cursor: "pointer"}} icon={faQuestionCircle} /></p>
                        <form onSubmit={onClickFinalizarCad}>
                            <div className={styles.fcCenterImages}>
                                <div>
                                    <ImageInput name="Doc. profissional (frente)" register={register} registerName="frenteCrea" />
                                    { errors?.frenteCrea ?  (
                                            <HelperText text={errors?.frenteCrea?.message} />
                                    ) : '' }
                                </div>
                                <div>
                                    <ImageInput name="Doc. profissional (verso)" register={register} registerName="versoCrea" />
                                </div>
                                <div>
                                    <ImageInput name="Selfie c/ identidade" register={register} registerName="selfie" />
                                </div>
                            </div>
                            <div className={styles.fcFormFields}>
                                <FormControl variant="outlined" style={{ width: '230px' }}>
                                    <InputLabel htmlFor="cadastro-datavalidadecrea" shrink style={{ color: "#b8b8b8", zIndex: 0}}>
                                        Data de validade do documento
                                    </InputLabel>
                                    <Controller 
                                        name="dataValidadeCrea"
                                        control={control}
                                        render={({ field }) => (
                                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                                <DatePicker 
                                                    {...field}
                                                    error={!!errors.dataValidadeCrea}
                                                    inputFormat="dd/MM/yyyy"
                                                    label="Data de validade do documento"
                                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                                        <>
                                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{color: "#fff"}} className={`${errors?.dataValidadeCrea ? styles.campoComValorErrado : ""}`} placeholder="__/__/____"/>
                                                            <span style={{ position: "absolute", top: 38, right: 15, color: "white", svg: "white", input: "white", label: "white" }}>
                                                                {InputProps?.endAdornment}
                                                            </span>
                                                        </>
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        )}
                                    />
                                    { errors?.dataValidadeCrea ?  (
                                        <HelperText text={errors?.dataValidadeCrea?.message} />
                                    ) : '' }
                                </FormControl>
                            </div>
                            <div className={styles.fcFormFields}>
                                <Controller 
                                    name="empresa"
                                    control={control}
                                    render={({field}) => (
                                        <FormControl variant="outlined" sx={{ width: "49%" }}>
                                            <InputLabel htmlFor="cadastro-empresa" shrink style={{ color: "#C8C8C8"}}>Empresa vinculada</InputLabel>
                                            <WhiteInput 
                                                fullWidth
                                                placeholder="Empresa Ltda."
                                                id="cadastro-empresa"
                                                error={!!errors.empresa}
                                                {...field}
                                                className={`${errors?.empresa ? styles.campoComValorErrado : ""}`}
                                            />
                                        { errors?.empresa ?  (
                                            <HelperText text={errors?.empresa?.message} />
                                        ) : '' }
                                        </FormControl>
                                    )}
                                
                                />
                                <Controller 
                                    name="creadoc"
                                    control={control}
                                    render={({field}) => (
                                        <FormControl variant="outlined" sx={{ width: "49%" }}>
                                            <InputLabel htmlFor="cadastro-creadoc" shrink style={{ color: "#C8C8C8" }}>Nº doc. profissional</InputLabel>
                                            <WhiteInput 
                                                fullWidth
                                                placeholder="000000000000000"
                                                id="cadastro-creadoc"
                                                error={!!errors.creadoc}
                                                {...field}
                                                className={`${errors?.creadoc ? styles.campoComValorErrado : ""}`}
                                            />
                                            { errors?.creadoc ?  (
                                                <HelperText text={errors?.creadoc?.message} />
                                            ) : '' }
                                        </FormControl>
                                    )}
                                />
                                { !isHidden && (
                                    <>
                                        <Controller
                                            name="nome"
                                            control={control}
                                            render={({field}) => (
                                                <FormControl variant="outlined" sx={{ width: "49%" }}>
                                                    <InputLabel htmlFor="cadastro-nome" shrink style={{ color: "#C8C8C8"}}>Nome completo</InputLabel>
                                                    <WhiteInput 
                                                        fullWidth
                                                        placeholder="Nome"
                                                        id="cadastro-nome"
                                                        error={!!errors.nome}
                                                        {...field}
                                                        className={`${errors?.nome ? styles.campoComValorErrado : ""}`}
                                                    />
                                                    { errors?.nome ?  (
                                                        <HelperText text={errors?.nome?.message} />
                                                    ) : '' }
                                                </FormControl>
                                            )}
                                        />
                                        <Controller
                                            name="email"
                                            control={control}
                                            render={({field}) => (
                                                <FormControl variant="outlined" sx={{ width: "49%" }}>
                                                    <InputLabel htmlFor="cadastro-email" shrink style={{ color: "#C8C8C8" }}>E-mail</InputLabel>
                                                    <WhiteInput 
                                                        fullWidth
                                                        type="email"
                                                        placeholder="E-mail"
                                                        error={!!errors.email}
                                                        {...field}
                                                        className={`${errors?.email ? styles.campoComValorErrado : ""}`}
                                                    />
                                                    { errors?.email ?  (
                                                        <HelperText text={errors?.email?.message} />
                                                    ) : '' }
                                                </FormControl>
                                            )}
                                        />
                                        <Controller
                                            name="celular"
                                            control={control}
                                            render={({field: {onChange, value}}) => (
                                                <FormControl variant="outlined" sx={{ width: "49%" }}>
                                                    <InputLabel htmlFor="cadastro-celular" shrink style={{ color: "#C8C8C8"}}>Celular</InputLabel>
                                                    <InputMask 
                                                        mask="(99) 99999-9999"
                                                        onChange={onChange}
                                                        value={value}
                                                        id="cadastro-celular"
                                                    >
                                                        {inputProps => (
                                                            <WhiteInput 
                                                                fullWidth
                                                                error={errors?.celular?.message}
                                                                {...inputProps}
                                                                className={`${errors?.celular ? styles.campoComValorErrado : ""}`}
                                                            />
                                                        )}
                                                    </InputMask>
                                                    { errors?.celular ?  (
                                                        <HelperText text={errors?.celular?.message} />
                                                    ) : '' }
                                                </FormControl>
                                            )}
                                        />
                                        <Controller 
                                            name="cpf"
                                            control={control}
                                            render={({field: {onChange, value}}) => (
                                                <FormControl variant="outlined" sx={{ width: "49%" }}>
                                                    <InputLabel htmlFor="cadastro-cpf" shrink style={{ color: "#C8C8C8" }}>CPF</InputLabel>
                                                    <InputMask
                                                        mask="999.999.999-99"
                                                        id="cadastro-cpf"
                                                        onChange={onChange}
                                                        value={value}
                                                    >
                                                        {inputProps => (
                                                            <WhiteInput 
                                                                fullWidth
                                                                error={errors?.cpf?.message}
                                                                {...inputProps}
                                                                className={`${errors?.cpf ? styles.campoComValorErrado : ""}`}
                                                            />
                                                        )}
                                                    </InputMask>
                                                    { errors?.cpf ?  (
                                                        <HelperText text={errors?.cpf?.message} />
                                                    ) : '' }
                                                </FormControl>
                                            )}
                                        />
                                    </>
                                )}
                            </div>
                            <p>Assim que você nos enviar todos os dados e os documentos para análise temos um prazo de <b>{prazoAnaliseCadRespTec} dias</b> para aprovar ou não o seu cadastro.</p>
                            <p>Fique atento aos meios de comunicação que você informou aqui (e-mail e telefone). Assim que a solicitação de habilitação for analisada enviaremos um e-mail de confirmação.</p>
                            <p>Após a solicitação de revisão do cadastro de habilitação, você possui o prazo de <b>{prazoAnaliseCadRespTec} dias</b> para revisar o seu cadastro e solicitar uma nova análise.</p>
                            <div style={ usaTermoConsentimentoRef.current ? 
                                    { margin: '-10px 15px 10px 0',  display: 'flex', justifyContent: 'right', alignItems: 'center' } : 
                                    { display: "none" }
                                }
                            >
                                <Checkbox 
                                    sx={{
                                        color: '#b8b8b8',
                                        '&.Mui-checked': {
                                            color: 'primary'
                                        }
                                    }}
                                    onClick={() => setAceitaTermoConsentimento(!aceitaTermoConsentimento)}
                                    checked={aceitaTermoConsentimento} 
                                />
                                <span style={{ fontSize: '13px',  color: '#b8b8b8' }}>
                                    Você concorda com os <a style={{...linkStyle, display: 'inline-block' }} onClick={() => abrirTermos()}>Termos de consentimento</a>?
                                </span>
                            </div>
                            <div className={styles.fcFormButtons}>
                                <BlueHoverButton variant="contained" onClick={(e) => setIsHidden(!isHidden)}>Revisar o cadastro</BlueHoverButton>
                                <BlueHoverButton disabled={disableBtnConcluir} variant="contained" type="submit">Enviar para análise</BlueHoverButton>
                            </div>
                        </form>
                    </div>
                    <div className={styles.fcRightImage}>
                        <img src={ImagemLateralD} alt="Mundo com duas pessoas" />
                    </div>
            </main>
            <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose}> 
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
            </Snackbar>
            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
            <Modal open={openQuaseLa}>
                <Box style={ModalQuaseLaStyle}>
                    <h2 className={styles.modalTitulo}>Quase lá</h2>
                    <div className={styles.modalConteudo}>
                        <div className={styles.modalImagem}>
                            <img src={QuaseLa} alt="Desenho de pessoas correndo com obstáculos"/>
                        </div>
                        <div className={styles.modalTexto}>
                        <p>Antes de analisarmos o seu cadastro precisamos de mais alguns documentos.</p>
                        </div>
                    </div>
                    <div className={styles.modalBotao}>
                        <BlueHoverButton onClick={handleCloseModal}>
                            Continuar
                        </BlueHoverButton>
                    </div>
                </Box>
            </Modal>
        </Box>
    );
}

export { FinalizarCadastro };